import type { Store } from 'vuex';

export default function createStoreResetPlugin(){
  return (store: Store<any>) => {
    // Reset on auth mutations that clear token
    store.subscribe((mutation, state) => {
      if (mutation.type === 'setUser' || mutation.type === 'auth/setUser') {
        const token = state.token ?? state.auth?.token ?? null;
        if (!token) {
          resetAll(store);
        }
      }
    });

    // Reset after logout/delete account actions complete
    store.subscribeAction({
      after(action) {
        if (action.type === 'logout' || action.type === 'auth/logout' || action.type === 'auth/deleteAccount') {
          resetAll(store);
        }
      }
    });
  };
}

function resetAll(store: Store<any>) {
  // Namespaced module cleanups guarded by module/action presence
  const hasAction = (type: string) => Array.isArray((store as any)._actions?.[type]);
  const hasMutation = (type: string) => Array.isArray((store as any)._mutations?.[type]);

  if (hasAction('device/cleanData')) store.dispatch('device/cleanData');
  if (hasAction('alarms/cleanData')) store.dispatch('alarms/cleanData');
  if (hasAction('catalog/clearCache')) store.dispatch('catalog/clearCache');
  if (hasMutation('notifications/clearAll')) store.commit('notifications/clearAll');
  if (hasMutation('selection/reset')) store.commit('selection/reset');
}


